import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "video",
    "toggle",
    "progressBar",
    "playIcon",
    "pauseIcon"
  ]

  static values = {
    isPaused: { type: Boolean, default: true }
  }

  connect() {
    this.updateProgressInterval = null;
  }

  togglePlay(event) {
    const method = this.isPausedValue ? "play" : "pause"
    this.videoTarget[method]()

    this.isPausedValue = !this.isPausedValue

    const iconTemplate = this.isPausedValue ? this.playIconTarget : this.pauseIconTarget
    const icon = iconTemplate.content.cloneNode(true);
    this.toggleTarget.replaceChildren(icon)

    if (!this.isPausedValue) {
      this.updateProgressInterval = setInterval(() => this.progressUpdate(), 50);
    } else {
      clearInterval(this.updateProgressInterval);
    }
  }

  progressUpdate(event) {
    const percent = this.videoTarget.currentTime / this.videoTarget.duration * 100
    this.progressBarTarget.style.flexBasis = `${percent}%`
  }

  disconnect() {
    clearInterval(this.updateProgressInterval);
  }
}
